/**
 * @utility-ng-log
 */
var log = require('utility-js-log');

log.system = log;
log.user = log.create('user');

module.exports = 'utility-ng-log';
angular.module('utility-ng-log', []).constant('log', log);



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-log/src/main.js